import {useEncounterViewPort} from "@/encounter/viewport/EncounterViewPortHooks.ts";
import {gridToWorld, worldToGrid} from "@/dungeons/geometry/Coordinates.ts";
import type {Annotation, LevelGrid} from "@/dungeons/model/DungeonGeometry.ts";
import {useTableTopSelection} from "@/tabletop/selection/TableTopSelectionHooks.ts";
import AnnotationMarker from "@/dungeons/annotations/AnnotationMarker.tsx";
import type {MapAnnotation} from "./MapAnnotation.ts";

export default function GameMasterAnnotationLayer({annotations, grid, selected, editing, onSelect, onMoveEncounter}: {
    annotations: MapAnnotation[];
    grid: LevelGrid;
    selected?: MapAnnotation;
    editing: boolean;
    onSelect: (item: MapAnnotation) => void;
    onMoveEncounter: (item: MapAnnotation, position: Annotation["position"]) => void;
}) {
    const {mapTransform} = useEncounterViewPort();
    const {clearSelection} = useTableTopSelection();
    const zoom = mapTransform.scale;
    const select = (item: MapAnnotation) => {
        clearSelection();
        onSelect(item);
    };

    return <>{annotations.map(item => {
        const annotation = item.annotation;
        const position = gridToWorld(annotation.position, grid);
        const isSelected = selected?.source === item.source && selected.annotation.id === annotation.id;
        return <AnnotationMarker key={`${item.source}:${annotation.id}`} annotation={annotation}
            x={position.x} y={position.y} zoom={zoom} selected={isSelected}
            draggable={item.source === "encounter" && !(isSelected && editing)}
            onMouseDown={event => {event.cancelBubble = true;}}
            onClick={event => {event.cancelBubble = true; select(item);}}
            onTap={event => {event.cancelBubble = true; select(item);}}
            onDragStart={() => select(item)}
            onDragEnd={event => {
                event.cancelBubble = true;
                if (item.source === "encounter") onMoveEncounter(item,
                    worldToGrid({x: event.target.x(), y: event.target.y()}, grid));
            }}/>;
    })}</>;
}
